/**
 * Brand identity decoration:
 *   • Vertical repeating pattern strip anchored to the page edge (fixed).
 *   • Soft ghost Dowakum logo mark for section accents.
 * Both are marked aria-hidden and use pointer-events: none so they never
 * interfere with layout or interactions.
 */
export const BRAND_PATTERN = 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/6e668nqo_aaa.webp';
export const BRAND_MARK    = 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/pkgaynak_logo%20white.webp';

export function BrandPatternStrip() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed top-0 bottom-0 z-[5] hidden md:block start-0"
      style={{
        width: 72,
        backgroundImage: `url(${BRAND_PATTERN})`,
        backgroundRepeat: 'repeat-y',
        backgroundSize: '72px auto',
        backgroundPosition: 'top left',
        opacity: 0.35,
        filter: 'drop-shadow(0 4px 10px rgba(137,72,195,0.15))',
        maskImage:
          'linear-gradient(to bottom, transparent 0%, black 6%, black 94%, transparent 100%)',
        WebkitMaskImage:
          'linear-gradient(to bottom, transparent 0%, black 6%, black 94%, transparent 100%)',
      }}
    />
  );
}

/**
 * Dowakum icon-only mark (real transparent PNG, mirrored horizontally per client request).
 */
export const DOWAKUM_MARK_URL =
  'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/c10bny6q_%D9%84%D9%88%D9%83%D9%88%20%D9%86%D8%B5%D9%81%20%D9%8A%D9%85%D9%8A%D9%86.png';

export function DowakumMark({ size = 460, className = '', style = {} }) {
  return (
    <img
      src={DOWAKUM_MARK_URL}
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      className={className}
      style={{
        width: size,
        height: 'auto',
        ...style,
      }}
    />
  );
}


